const API_NAME = process.env.REACT_APP_API_NAME
  ? `/${process.env.REACT_APP_API_NAME}`
  : "";
const BASE_URL = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_IP}${API_NAME}`;

//По цьому урлу відпраляються запити. Наприклад url: `${apiBaseurl}/cases'
export const API_BASE_URL = `${BASE_URL}/api`;
